<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('APTR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['PTRPT']['PT']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT <= 2 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="true"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                <treeselect :options="ddCurrency"
                                            :placeholder="this.utilGetDDLanguage('MTA.C')"
                                            v-model="searchCurrency" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['PTRPT']['PTL']}}</strong>
                    <div class="pageBtn">
                        <div class="d-flex align-items-center">
                            <span class='searchLabel'> {{this.getLanguage["PTV"]["PTV"]}} :</span>
                            <input type="checkbox"
                                   v-model="ChangeView" />
                        </div>
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th>{{this.getLanguage['BETRPT']['GP']}}</th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['PTRPT']['PPT']}}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT == 0">
                                    {{this.getLanguage['PTRPT']['SPT']}}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 1">
                                    {{getUserInfo.AT == 1? this.getLanguage['PTRPT']['SPT'] + '(SM)': this.getLanguage['PTRPT']['SAPT'] }}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 2">
                                    {{getUserInfo.AT == 2? this.getLanguage['PTRPT']['SPT'] + '(MA)': this.getLanguage['PTRPT']['MAPT'] }}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 3">
                                    {{getUserInfo.AT == 3? this.getLanguage['PTRPT']['SPT'] + '(A)': this.getLanguage['PTRPT']['APT'] }}
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th>{{this.getLanguage['BETRPT']['GP']}}</th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['PTRPT']['PPT']}}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT == 0">
                                    {{this.getLanguage['PTRPT']['SPT']}}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 1">
                                    {{getUserInfo.AT == 1? this.getLanguage['PTRPT']['SPT'] + '(SM)': this.getLanguage['PTRPT']['SAPT'] }}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 2">
                                    {{getUserInfo.AT == 2? this.getLanguage['PTRPT']['SPT'] + '(MA)': this.getLanguage['PTRPT']['MAPT'] }}
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 3">
                                    {{getUserInfo.AT == 3? this.getLanguage['PTRPT']['SPT'] + '(A)': this.getLanguage['PTRPT']['APT'] }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-if="!ChangeView" v-for="(data,index) in arr_reportList">
                            <tr v-if="data.AGN" class="table-row-subheader">
                                <td colspan="12">
                                    <router-link :to="{ path:'/R/WINLV2', query:{ gpi: data.GPI, as: 't' }}" target="_blank">
                                        <b>{{ data.AGN }}</b>
                                    </router-link>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ renderProviderName(data.row) }}</td>
                                <td>{{ renderProviderName(data.PN) }}</td>
                                <td width="100px" :class="data.PPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PPT, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT == 0" :class="data.PT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PT, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT <= 1" :class="data.SAPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.SAPT,2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT <= 2" :class="data.MAPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.MAPT, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT <= 3" :class="data.APT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.APT, 2, '') }}
                                </td>
                            </tr>
                        </template>
                        <template v-if="ChangeView" v-for="(data,index) in arr_reportList">
                            <tr v-if="data.AGN" class="table-row-subheader">
                                <td colspan="12">
                                    <router-link :to="{ path:'/R/WINLV2', query:{ sagi: '3-'+data.AGI, agi: data.AGI, as: 't' }}" target="_blank">
                                        <b>{{ data.AGN }}</b>
                                    </router-link>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ renderProviderName(data.row) }}</td>
                                <td>{{ renderProviderName(data.PN) }}</td>
                                <td width="100px" :class="data.PTVPPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PTVPPT, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT == 0" :class="data.PTVPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PTVPT, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT <= 1" :class="data.PTVSAPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PTVSAPT,2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT <= 2" :class="data.PTVMAPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PTVMAPT, 2, '') }}
                                </td>
                                <td width="100px" v-if="getUserInfo.AT <= 3" :class="data.PTVAPT >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">
                                    {{ formatNumber(data.PTVAPT, 2, '') }}
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            Loading
        },
        data() {
            return {
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                ddGameProviderList: null,
                ddCurrency: null,
                // search fields
                searchAgi: 0,
                searchAgi2: 0,
                searchAgi3: 0,
                searchAgent: null,
                searchCurrency: null,
                ChangeView: true,
                searchGameProviderId: [],
                arr_reportList: [],
                skipPageUpdate: false,
                constAccessType: constAccessType,
                row: 1,
                hideBrand: false,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag2/0/0/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.searchAgi = 0;
                this.searchAgi2 = 0;
                this.searchAgi3 = 0;
                if (value) {
                    var temp = this.getAgentDetailList(this.ddAgentList, value);
                    if (temp) {
                        var t = temp.split("|");
                        if (t.length == 1) {
                            var agentList = t[0].split("-");
                            this.searchAgi = agentList[agentList.length - 1];
                        }
                        else if (t.length == 2) {
                            var agentList = t[1].split("-");
                            this.searchAgi = agentList[agentList.length - 1];

                            agentList = t[0].split("-");
                            this.searchAgi2 = agentList[agentList.length - 1];
                        }
                        else if (t.length == 3) {
                            var agentList = t[2].split("-");
                            this.searchAgi = agentList[agentList.length - 1];

                            agentList = t[1].split("-");
                            this.searchAgi2 = agentList[agentList.length - 1];

                            agentList = t[0].split("-");
                            this.searchAgi3 = agentList[agentList.length - 1];
                        }
                    }
                }
            },
            getAgentDetailList(list, value) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].id == value) {
                        return list[i].id;
                    }
                    else if (list[i].children && list[i].children.length > 0) {
                        var temp = this.getAgentDetailList(list[i].children, value);
                        if (temp) {
                            return temp + '|' + list[i].id;
                        }
                    }
                }

                return null;
            },
            getCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.ddCurrency = d.dropdownlist;
                        }
                    });
            },
            selectGameProvider(value, instanceId) {

            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            newsearch() {
                this.$refs.search.focus();
                this.getReportList();
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;

                var path = '';

                if (this.searchAgi > 0) {
                    path += "&AGI=" + this.searchAgi;
                }

                if (this.searchAgi2 > 0) {
                    path += "&AGI2=" + this.searchAgi2;
                }

                if (this.searchAgi3 > 0) {
                    path += "&AGI3=" + this.searchAgi3;
                }

                if (this.searchGameProviderId != null && this.searchGameProviderId.length == 1) {
                    path += "&GPI=" + this.searchGameProviderId;
                }
                else {
                    path += "&GPI_csv=" + this.searchGameProviderId;
                }

                if (this.searchCurrency) {
                    path += "&CI=" + this.searchCurrency;
                }

                if (path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/reports/positiontaking?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.temp_agentName = null;

                            if (d.D && d.D.Items) {
                                var temp_agentName = null;
                                for (var i = 0; i < d.D.Items.length; i++) {
                                    if (temp_agentName == d.D.Items[i].AGN) {
                                        temp_agentName = d.D.Items[i].AGN;
                                        d.D.Items[i].AGN = null;
                                    }
                                    else {
                                        temp_agentName = d.D.Items[i].AGN;
                                        that.row = 1;
                                    }
                                    d.D.Items[i].row = that.row++;
                                }
                            }

                            that.arr_reportList = d.D.Items;
                            that.resizeTableHead();
                        }
                        else {
                            that.arr_reportList = [];
                        }
                    });
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {
                var path = '';

                if (this.searchAgi > 0) {
                    path += "&AGI=" + this.searchAgi;
                }

                if (this.searchAgi2 > 0) {
                    path += "&AGI2=" + this.searchAgi2;
                }

                if (this.searchAgi3 > 0) {
                    path += "&AGI3=" + this.searchAgi3;
                }

                if (this.searchGameProviderId != null && this.searchGameProviderId.length == 1) {
                    path += "&GPI=" + this.searchGameProviderId;
                }
                else {
                    path += "&GPI_csv=" + this.searchGameProviderId;
                }

                if (this.searchCurrency) {
                    path += "&CI=" + this.searchCurrency;
                }

                    path += "&PTView=" + this.ChangeView;

                if (path) {
                    path = path.substring(1);
                }

                window.open('/api/reports/positiontakingexcel?' + path, '_blank');

            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        watch: {
            getLanguage() {
                this.getReportList();
            },
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS1';
            this.$parent.showActiveMenu = 'R.APTR';

            this.hideBrand = this.getUserInfo.IHAGIF;

            this.getCurrencyList();
            this.getReportList();
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/PositionTaking.vue